import React from "react";

const Resume = () => {
  return (
    <div className="d-flex justify-content-center align-items-center text-light">
      <iframe
        src="images/resume.pdf"
        width="80%"
        height="600"
        frameborder="0"
      ></iframe>
    </div>
  );
};

export default Resume;
